import React from 'react';
import { Layout, Menu, Dropdown, Button, Row, Col, Typography, Card, Divider } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import '../App.css'; // Add your custom CSS styles here
import logo from '../images/Aptean Logo - Black.svg';
import ManagerDetail from './ManagerDetail';
import ListOfEmployee from './ListOfEmployee';
import NineBoxPage from './NineBoxPage';
import { AppProvider, useAppContext } from './AppContext';
import EmployeeTree from './EmployeeHierarchy';
import TeamSummary from './TeamSize';
import { useEffect, useState, useCallback } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';


const { Header, Content, Sider } = Layout;
const { Title } = Typography;
const { SubMenu } = Menu;


const AppLayout = () => {

  const [graphData, setGraphData] = useState(null);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const { upName, setUpName } = useAppContext();
  const { mailID, setMailID } = useAppContext();
  const { tableData, setTableData } = useAppContext();
  const { filteredTableData, setFilteredTableData } = useAppContext();
  const { accessToken, updateUserPrincipalName, setAccessToken, updateMailID } = useAppContext();
  const { setLoggedInMail, setLoggedInUPN } = useAppContext();
  const { setLoggedInName } = useAppContext();
  const { clearPersistedData } = useAppContext();

  // Replace these with your actual user data
  const userProfile = {
    username: graphData?.displayName,
    // avatar: 'https://placekitten.com/40/40', // URL to user's avatar
  };

  const colStyle = {
    border: '1px solid #ddd', // Set the border style
    padding: '20px', // Add padding for spacing inside the form
  };

  const handleSignOut = () => {
    // Clear persisted data on logout
    clearPersistedData();
    instance.logoutRedirect();
  }

  const menu = (
    <Menu onClick={handleSignOut}>
      <Menu.Item key="1" icon={<LogoutOutlined />}>
        Logout
      </Menu.Item>
    </Menu>
  );




  const fetchData = useCallback(async () => {
    try {
      let token = accessToken;
      
      // If we don't have a token or it's expired, try to get a fresh one
      if (!token) {
        try {
          const account = instance.getActiveAccount();
          const silentRequest = {
            scopes: ["User.Read", "User.Read.All"],
            account: account,
            forceRefresh: false
          };

          const tokenResponse = await instance.acquireTokenSilent(silentRequest);
          token = tokenResponse.accessToken;
          setAccessToken(token);
          
        } catch (tokenError) {
          console.error('Error acquiring token in AppLayout:', tokenError);
          
          // If silent token acquisition fails, try popup
          if (tokenError.name === 'BrowserAuthError' || 
              tokenError.message.includes('monitor_window_timeout') ||
              tokenError.message.includes('interaction_required')) {
            
            try {
              const popupResponse = await instance.acquireTokenPopup({
                scopes: ["User.Read", "User.Read.All"]
              });
              token = popupResponse.accessToken;
              setAccessToken(token);
              
            } catch (popupError) {
              console.error('Popup token acquisition failed:', popupError);
              // Redirect to login if all methods fail
              navigate('/');
              return;
            }
          }
        }
      }

      const response = await fetch('https://graph.microsoft.com/v1.0/me', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const data = await response.json();
      setGraphData(data);
      setUpName(data.userPrincipalName);
      setMailID(data.mail);
      setLoggedInMail(data.mail);
      setLoggedInUPN(data.userPrincipalName);
      setLoggedInName(data.displayName);

    } catch (error) {
      console.error('Error fetching data:', error);
      // If there's still an error, redirect to login
      navigate('/');
    }
  }, [accessToken, instance, setAccessToken, setUpName, setMailID, setLoggedInMail, setLoggedInUPN, setLoggedInName, navigate]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
      return;
    }

    // If we have persisted user data, restore the userProfile
    if (upName && mailID && !graphData) {
      const displayName = localStorage.getItem('loggedInName') || '';
      setGraphData({
        userPrincipalName: upName,
        mail: mailID,
        displayName: displayName
      });
    } else if (accessToken && !upName && !mailID) {
      // Only fetch data if we don't have it persisted
      fetchData();
    }

  }, [accessToken, isAuthenticated, upName, mailID, graphData, fetchData]);

  return (
    <Layout style={{ minHeight: '100vh' }}>

      <Layout>

        <Header style={{ background: 'white', padding: '0 16px' }}>
          <Row align="middle">
            <Col >
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <img src={logo} alt="Logo" style={{ height: '40px', width: '80px', margin: 5 }} />
                <Divider type="vertical" style={{ height: '40px', width: '2px', color: 'black', backgroundColor: 'lightgrey', marginLeft: 10, marginTop: 7, marginRight: 10 }} />
                <Title style={{ marginTop: 12, color: 'black', fontFamily: 'unset', fontSize: 20 }}>
                  Aptean Talent Review
                </Title>
              </div>
            </Col>
            <Col>

            </Col>
            <Col flex="auto" style={{ textAlign: 'left' }}>

            </Col>
            <Col>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Dropdown overlay={menu} placement="middleRight" arrow>
                  <Button type="text" style={{ marginLeft: 8, marginBottom: 10, color: 'black', marginTop: 10 }}>
                    {userProfile.username} <UserOutlined />
                  </Button>
                </Dropdown>
              </div>
            </Col>
          </Row>

        </Header>
        <Content >
          {/* <AppProvider> */}
          <Layout style={{ margin: 10 }}>
            <Content  >
              <Row>
                <Col>
                  <EmployeeTree clickable />
                </Col>
              </Row>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Card style={{ display: 'flex', alignItems: 'center' }}>
                    <div >
                      <ManagerDetail />
                    </div>
                    <div >
                      <TeamSummary />
                    </div>
                  </Card>
                </Col>

                <Col span={16}>
                  <Card >

                    <div style={{ padding: '10px', display: 'flex', justifyContent: 'space-around' }}>
                      <NineBoxPage />
                    </div>
                  </Card>
                </Col>
              </Row>
            </Content>

          </Layout>
          <Layout style={{ margin: 10 }}>
            <ListOfEmployee />
          </Layout>
          {/* </AppProvider> */}

        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
